import { render, staticRenderFns } from "./DemoToolResult.vue?vue&type=template&id=10cd9480&scoped=true&"
import script from "./DemoToolResult.vue?vue&type=script&lang=js&"
export * from "./DemoToolResult.vue?vue&type=script&lang=js&"
import style0 from "./DemoToolResult.vue?vue&type=style&index=0&id=10cd9480&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10cd9480",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
